import CurrencyTotalItem from './CurrencyTotalItem.js'
import lang from '@/lang'
import { getForeignExchangeRateSafely, localCurrencyByOffice, useAmountCarryRule, getCurrency } from '@/class/cargo/model/utils/RateUtil'
import BigNumber from 'bignumber.js'
import * as NumberUtils from '@/utils/NumberUtils'
import { roundHalfUp2 } from '@/utils/NumberUtils'
import $store from '@/store'
export default class ChargeCurrencyTotalGroup {
  constructor(data) {
    this._data = data || { resultList: [] }
    this.currencyAmountMap = {}
  }

  // // 处理结果的list
  get resultList() {
    return this._data.resultList
  }

  set resultList(value) {
    this._data.resultList = value
  }
  get type() {
    return this._data.type || 'all'
  }

  set type(value) {
    this._data.type = value
  }

  get grossMargin() {
    return this._data.grossMargin
  }

  set grossMargin(value) {
    this._data.grossMargin = value
  }

  get showB() {
    return this._data.showB
  }

  set showB(value) {
    this._data.showB = value
  }

  get dataProvider() {
    return this._data.dataProvider || []
  }

  set dataProvider(value) {
    this._data.dataProvider = value
  }
  // 应付受控
  get showControlled() {
    return this._data.showControlled || true
  }

  set showControlled(value) {
    this._data.showControlled = value
  }

  get showCostControlled() {
    return this._data.showCostControlled || true
  }

  set showCostControlled(value) {
    this._data.showCostControlled = value
  }

  get dataField() {
    return this._data.dataField || 'amount'
  }

  set dataField(value) {
    this._data.dataField = value
  }
  get source() {
    return this._data.source || ''
  }
  set source(value) {
    this._data.source = value
  }
  // 折合币种
  get amountToCurrency() {
    return this._data.amountToCurrency || null
  }

  set amountToCurrency(value) {
    this._data.amountToCurrency = value
  }
  // 折合标签
  get amountToCurrencyLabel() {
    return this._data.amountToCurrencyLabel || lang.t('SeaExport.Convert')
  }

  set amountToCurrencyLabel(value) {
    this._data.amountToCurrencyLabel = value
  }

  get arLabel() {
    return this._data.arLabel || lang.t('SeaExport.Received')
  }

  set arLabel(value) {
    this._data.arLabel = value
  }

  get apLabel() {
    return this._data.apLabel || lang.t('SeaExport.Paid')
  }

  set apLabel(value) {
    this._data.apLabel = value
  }

  get currencyField() {
    return this._data.currencyField || 'currency'
  }

  set currencyField(value) {
    this._data.currencyField = value
  }
  // 汇率，如果不取系统汇率而是取数据源中的汇率时使用。
  get rateField() {
    return this._data.rateField || 'rate'
  }

  set rateField(value) {
    this._data.rateField = value
  }
  // 收付字段
  get arField() {
    return this._data.arField || 'isAr'
  }

  set arField(value) {
    this._data.arField = value
  }
  // 是否应收在auto模式下有用
  get isAr() {
    return this._data.isAr || true
  }

  set isAr(value) {
    this._data.isAr = value
  }
  // 是否分实收实付
  get arapGroup() {
    return this._data.arapGroup || false
  }

  set arapGroup(value) {
    this._data.arapGroup = value
  }

  get mode() {
    return this._data.mode || 'group'
  }

  set mode(value) {
    this._data.mode = value
  }
  // 应收应付计算顺序 defaultValue="ar", enumeration="ar,ap"
  get arapOrder() {
    return this._data.arapOrder || this.AR
  }

  set arapOrder(value) {
    this._data.arapOrder = value
  }

  get showControlledProfit() {
    return this._data.showControlledProfit || false
  }

  set showControlledProfit(value) {
    this._data.showControlledProfit = value
  }

  get isGrossProfit() {
    return this._data.isGrossProfit || false
  }

  set isGrossProfit(value) {
    this._data.isGrossProfit = value
  }

  get auxiliaryMap() {
    return this._data.auxiliaryMap || null
  }

  set auxiliaryMap(value) {
    this._data.auxiliaryMap = value
  }

  get showWht() {
    return this._data.showWht || false
  }

  set showWht(value) {
    this._data.showWht = value
  }

  get onlyShowConvert() {
    return this._data.onlyShowConvert || false
  }

  set onlyShowConvert(value) {
    this._data.onlyShowConvert = value
  }

  get currencyConversionInInvoices() {
    return this._data.currencyConversionInInvoices || false
  }
  set currencyConversionInInvoices(value) {
    this._data.currencyConversionInInvoices = value
  }

  // --------------------------------------------------------------------
  //
  // Constants
  //
  // --------------------------------------------------------------------

  /**
   * 利润
   */
 static REVENUE = 'revenue';

 /**
   * 应收
   */
 static AR = 'ar';

 /**
   * 应付
   */
 static AP = 'ap';

 /**
   * 所有
   */
 static BOTH = 'both';

 /**
   * 利润绝对值
   */
 static REVENUE_ABS = 'revenueAbs';

 /**
   * 自动
   */
 static AUTO = 'auto';

 /**
   * 根据币种获取合计
   */
 getAmountByCurrency(currency) {
   return this.currencyAmountMap.hasOwnProperty(currency) ? this.currencyAmountMap[currency] : 0
 }

 /**
   * 重新计算
   */
 recalc() {
   if (this.mode === 'simple') {
     this.simpleCalc()
   } else {
     this.groupingCalc()
   }
 }
 grossMarginRecalc(isCalculateExcludingAmount) {
   // 应收
   let r = 0
   // 应付
   let p = 0
   for (const charge of this.dataProvider || []) {
     const amount = new BigNumber(isCalculateExcludingAmount ? charge.amount : charge.excludingTaxAmount)
     const exchangeRate = new BigNumber(charge.exchangeRate)
     const num = NumberUtils.ToFixed2(amount * exchangeRate, 2)
     // 应收
     if (charge.receivable) {
       r += num
     } else {
       p += num
     }
   }
   if (r !== 0) {
     r = NumberUtils.ToFixed2(r, 2)
   }
   if (p !== 0) {
     p = NumberUtils.ToFixed2(p, 2)
   }
   if (r === 0) {
     this.grossMargin = -p
     this.showB = false
   } else {
     this.grossMargin = roundHalfUp2((r - p) / r * 100, 2)
     this.showB = true
   }
 }
 /**
   * 重新计算【费用业签调用】
   */
 async recalcCharge() {
   if (this.mode === 'simple') {
     this.simpleCalc()
   } else {
     await this.groupingCalc()
   }
 }

 /**
   * 简单汇总
   */
 simpleCalc() {
   let total = new BigNumber(0)
   let totalCostInterest = new BigNumber(0)
   for (const item of this.dataProvider || []) {
     let controlled = false
     if (item.hasOwnProperty('receivable')) {
       controlled = ((!this.showCostControlled && item.receivable) || (!this.showControlled && !item.receivable)) && item.controlled
     }

     if (controlled) { continue }

     const amount = item.hasOwnProperty(this.dataField) ? (isNaN(item[this.dataField]) ? 0 : item[this.dataField]) : 0
     total = total.plus(amount)

     // 新增：计算应收费用利息
     if (item.receivable && item.costInterest !== undefined && item.costInterest !== null) {
       totalCostInterest = totalCostInterest.plus(new BigNumber(item.costInterest))
     }
   }

   const list = []
   const totalItem = new CurrencyTotalItem(total, this.amountToCurrencyLabel)
   list.push(totalItem)

   // 新增：添加应收费用利息显示
   if (totalCostInterest.toNumber() !== 0) {
     const localCurrency = $store.getters.currentOffice.currency || 'CNY'
     list.push(new CurrencyTotalItem(new BigNumber(totalCostInterest.toFixed(2, BigNumber.ROUND_HALF_UP)), '应收费用利息(折合' + localCurrency + ')'))
   }

   this.resultList.splice(0, this.resultList.length, ...list)
   // console.log('this.resultList', this.resultList)
 }

 /**
   * 按币种分组汇总
   */
 async groupingCalc() {
   const specialHandling = ['Writeoff', 'invoiceDetail', 'chargeDetailAp', 'chargeDetailAr', 'chargeDetailAll', 'bankSlipCharge']
   const useGroupedInvoiceConversion = this.currencyConversionInInvoices
   // console.log('groupingCalc this.dataProvider', this.dataProvider)
   const localCurrency = await localCurrencyByOffice()
   let amount
   this.currencyAmountMap = {}
   const currencyAmountToMap = {}
   const currencyAmountToArMap = {}
   const currencyAmountToApMap = {}
   const currencyRateMap = {}
   const arCurrencyAmountMap = {}
   const apCurrencyAmountMap = {}
   // 新增：用于 currencyConversionInInvoices 参数开启时，存储每个币种的汇率
   const currencyRateForConversionMap = {}
   let amountTo = new BigNumber(0)
   // let arAmountTo = new BigNumber(0)
   // let apAmountTo = new BigNumber(0)
   let totalAr = new BigNumber(0)
   let totalAp = new BigNumber(0)
   // 新增：应收费用利息总额
   let totalCostInterest = new BigNumber(0)
   let currency = localCurrency
   let itemAmount
   let itemCurrency = localCurrency
   // let arOriginalAmountSum = 0
   // let apOriginalAmountSum = 0
   // let originalAmountSum = 0
   // let checkOriginal = false
   this.currencyMap = {}

   // CARGO-23590 伟轮12634：未核销列表下方合计金额与销账功能列表里面金额不一致
   if (this.source && specialHandling.includes(this.source)) {
     // 币种分组 用于过滤汇总金额0的币种
     for (const item of this.dataProvider || []) {
       if (this.currencyField.trim().length > 0 && item.hasOwnProperty(this.currencyField)) {
         itemCurrency = item[this.currencyField]
       }
       if (!this.currencyMap.hasOwnProperty(itemCurrency)) {
         this.currencyMap[itemCurrency] = new BigNumber(0)
       }
       itemAmount = item.hasOwnProperty(this.dataField) ? (isNaN(item[this.dataField]) ? new BigNumber(0) : new BigNumber(item[this.dataField])) : new BigNumber(0)
       this.currencyMap[itemCurrency] = this.currencyMap[itemCurrency].plus(itemAmount)
     }
   }

   // 发票详情右下角 先计算是否仅一种币种，且为计算后为0
   // const currencyNum = Object.keys(this.currencyMap).length
   // if (this.source && specialHandling.includes(this.source) && currencyNum === 1) {
   //   checkOriginal = true
   // }
   let scale = 2 // 小数位数
   let roundingMode = BigNumber.ROUND_HALF_UP
   const carryRule = useAmountCarryRule()
   if (carryRule && this.amountToCurrency) {
     const currencyData = getCurrency(this.amountToCurrency)
     if (currencyData !== null) {
       scale = currencyData.defaultFractionDigits
       if (currencyData.carryRule === 1) { // 进位规则：0=四合五入、1=舍位
         roundingMode = BigNumber.ROUND_DOWN
       } else {
         roundingMode = BigNumber.ROUND_HALF_UP
       }
     }
   }
   for (const item of this.dataProvider || []) {
     let controlled = false
     if (item.hasOwnProperty('receivable')) {
       controlled = ((!this.showCostControlled && item.receivable) || (!this.showControlled && !item.receivable)) && item.controlled
     }
     if (controlled && (this.isGrossProfit ? !this.showControlledProfit : true)) {
       continue
     }
     // 新增：计算应收费用利息
     if (item.receivable && item.costInterest !== undefined && item.costInterest !== null) {
       totalCostInterest = totalCostInterest.plus(new BigNumber(item.costInterest))
     }
     if (this.currencyField.trim().length > 0 && item.hasOwnProperty(this.currencyField)) {
       currency = item[this.currencyField]
     }
     if (!this.currencyAmountMap.hasOwnProperty(currency)) {
       this.currencyAmountMap[currency] = new BigNumber(0)
       currencyAmountToMap[currency] = new BigNumber(0)
       currencyAmountToArMap[currency] = new BigNumber(0)
       currencyAmountToApMap[currency] = new BigNumber(0)
       arCurrencyAmountMap[currency] = new BigNumber(0)
       apCurrencyAmountMap[currency] = new BigNumber(0)
       currencyRateMap[currency] = new Set()
     }

     if (this.type === ChargeCurrencyTotalGroup.REVENUE || this.type === ChargeCurrencyTotalGroup.REVENUE_ABS || this.type === ChargeCurrencyTotalGroup.BOTH || this.type === ChargeCurrencyTotalGroup.AUTO || item[this.arField] && this.type === ChargeCurrencyTotalGroup.AR || !item[this.arField] && this.type === ChargeCurrencyTotalGroup.AP) {
       let rate = 1
       if (this.amountToCurrency) {
         if (this.amountToCurrency !== currency) {
           if (this.rateField && item.hasOwnProperty(this.rateField) && (item[this.rateField] !== 0 || this.source === 'bankSlip')) {
             rate = item[this.rateField]
           } else {
             rate = await getForeignExchangeRateSafely(this.amountToCurrency, currency, new Date())
           }
         }
       } else {
         if (this.rateField && item.hasOwnProperty(this.rateField) && (item[this.rateField] !== 0 || this.source === 'bankSlip')) {
           rate = item[this.rateField]
         }
       }
       if (!rate) {
         rate = await getForeignExchangeRateSafely(this.amountToCurrency, currency, new Date())
       }
       currencyRateMap[currency].add(rate)
       // 新增：记录每个币种的汇率（用于 currencyConversionInInvoices 参数开启时）
       if (useGroupedInvoiceConversion && !currencyRateForConversionMap[currency]) {
         currencyRateForConversionMap[currency] = rate
       }
       amount = item.hasOwnProperty(this.dataField) ? (isNaN(item[this.dataField]) ? new BigNumber(0) : new BigNumber(item[this.dataField])) : new BigNumber(0)
       // amount = NumberUtils.roundHalfUp2(amount, 2)
       // CARGO-6672，如果发票币种不是RMB，返回RMB金额值，页面端不在根据发票金额 * 汇率
       let amount2RMB = new BigNumber(0)
       if (amount.toNumber() !== 0) {
         if (this.dataField === 'amount') {
           if (item.hasOwnProperty('amount2RMB') && !isNaN(item['amount2RMB'])) {
             amount2RMB = new BigNumber(item['amount2RMB'])
           }
         } else if (this.dataField === 'verifiedAmount') {
           if (item.hasOwnProperty('verifiedAmount2RMB') && !isNaN(item['verifiedAmount2RMB'])) {
             amount2RMB = new BigNumber(item['verifiedAmount2RMB'])
           }
         } else if (this.dataField === 'unverifiedAmount') {
           if (item.hasOwnProperty('unverifiedAmount2RMB') && !isNaN(item['unverifiedAmount2RMB'])) {
             amount2RMB = new BigNumber(item['unverifiedAmount2RMB'])
           }
         }
       }
       if (this.type === ChargeCurrencyTotalGroup.REVENUE || this.type === ChargeCurrencyTotalGroup.REVENUE_ABS || this.type === ChargeCurrencyTotalGroup.AUTO) {
         if (this.arapOrder === ChargeCurrencyTotalGroup.AP ? !item[this.arField] : item[this.arField]) {
           this.currencyAmountMap[currency] = amount.plus(this.currencyAmountMap[currency])
           arCurrencyAmountMap[currency] = amount.plus(arCurrencyAmountMap[currency])
           // 同币种总计大于0 才用汇率折合计算
           // 新增：当 currencyConversionInInvoices 参数开启时，跳过循环中的折合金额累加，在循环结束后统一计算
           if (useGroupedInvoiceConversion) {
             // 开启参数时，不在循环中累加折合金额，仅累加原币金额（已在上方完成）
           } else {
             if (this.source && this.source === 'Writeoff') { // 销账列表
               if (this.currencyMap && this.currencyMap[currency] && this.currencyMap[currency].toNumber() !== 0) {
                 currencyAmountToMap[currency] = (amount2RMB.toNumber() === 0) ? currencyAmountToMap[currency].plus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : currencyAmountToMap[currency].plus(amount2RMB.toFixed(scale, roundingMode))
                 // apAmountTo = (amount2RMB.toNumber() === 0) ? apAmountTo.plus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : apAmountTo.plus(amount2RMB.toFixed(scale, roundingMode))
               }
             } else {
               currencyAmountToMap[currency] = (amount2RMB.toNumber() === 0) ? currencyAmountToMap[currency].plus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : currencyAmountToMap[currency].plus(amount2RMB.toFixed(scale, roundingMode))
               // apAmountTo = (amount2RMB.toNumber() === 0) ? apAmountTo.plus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : apAmountTo.plus(amount2RMB.toFixed(scale, roundingMode))
             }
             // 发票详情页面右下角 所有费用同币种时
             // if (checkOriginal && amount.toNumber() !== 0) {
             //   apOriginalAmountSum = NumberUtils.ToFixed2(apOriginalAmountSum + amount.toNumber(), 2)
             // }
             // totalAr = (amount2RMB.toNumber() === 0) ? totalAr.plus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : totalAr.plus(amount2RMB.toFixed(scale, roundingMode))
             currencyAmountToArMap[currency] = (amount2RMB.toNumber() === 0) ? currencyAmountToArMap[currency].plus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : currencyAmountToArMap[currency].plus(amount2RMB.toFixed(scale, roundingMode))
           }
         } else {
           this.currencyAmountMap[currency] = this.currencyAmountMap[currency].minus(amount)
           // 新增：当 currencyConversionInInvoices 参数开启时，跳过循环中的折合金额累加，在循环结束后统一计算
           if (useGroupedInvoiceConversion) {
             // 开启参数时，不在循环中累加折合金额，仅处理 AP 原币金额累加
             if (this.arapOrder === ChargeCurrencyTotalGroup.AP && item[this.arField]) {
               apCurrencyAmountMap[currency] = apCurrencyAmountMap[currency].minus(amount)
             } else {
               apCurrencyAmountMap[currency] = apCurrencyAmountMap[currency].plus(amount)
             }
           } else {
             if (this.source && this.source === 'Writeoff') { // 销账列表
               // 同币种总计大于0 才用汇率折合计算
               if (this.currencyMap && this.currencyMap[currency] && this.currencyMap[currency].toNumber() !== 0) {
                 currencyAmountToMap[currency] = (amount2RMB.toNumber() === 0) ? currencyAmountToMap[currency].minus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : currencyAmountToMap[currency].minus(amount2RMB.toFixed(scale, roundingMode))
                 // arAmountTo = (amount2RMB.toNumber() === 0) ? arAmountTo.minus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : arAmountTo.minus(amount2RMB.toFixed(scale, roundingMode))
               }
             } else {
               currencyAmountToMap[currency] = (amount2RMB.toNumber() === 0) ? currencyAmountToMap[currency].minus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : currencyAmountToMap[currency].minus(amount2RMB.toFixed(scale, roundingMode))
               // arAmountTo = (amount2RMB.toNumber() === 0) ? arAmountTo.minus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : arAmountTo.minus(amount2RMB.toFixed(scale, roundingMode))
             }
             // 发票详情页面右下角 所有费用同币种时
             // if (checkOriginal && amount.toNumber() !== 0) {
             //   arOriginalAmountSum = NumberUtils.ToFixed2(arOriginalAmountSum + amount.toNumber(), 2)
             // }
             if (this.arapOrder === ChargeCurrencyTotalGroup.AP && item[this.arField]) {
               apCurrencyAmountMap[currency] = apCurrencyAmountMap[currency].minus(amount)
               // totalAp = (amount2RMB.toNumber() === 0) ? totalAp.minus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : totalAp.minus(amount2RMB.toFixed(scale, roundingMode))
               currencyAmountToApMap[currency] = (amount2RMB.toNumber() === 0) ? currencyAmountToApMap[currency].minus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : currencyAmountToApMap[currency].minus(amount2RMB.toFixed(scale, roundingMode))
             } else {
               apCurrencyAmountMap[currency] = apCurrencyAmountMap[currency].plus(amount)
               // totalAp = (amount2RMB.toNumber() === 0) ? totalAp.plus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : totalAp.plus(amount2RMB.toFixed(scale, roundingMode))
               currencyAmountToApMap[currency] = (amount2RMB.toNumber() === 0) ? currencyAmountToApMap[currency].plus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : currencyAmountToApMap[currency].plus(amount2RMB.toFixed(scale, roundingMode))
             }
           }
         }
       } else {
         this.currencyAmountMap[currency] = this.currencyAmountMap[currency].plus(amount)
         // amountTo = (amount2RMB.toNumber() === 0) ? amountTo.plus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : amountTo.plus(amount2RMB.toFixed(scale, roundingMode))
         currencyAmountToMap[currency] = (amount2RMB.toNumber() === 0) ? currencyAmountToMap[currency].plus(amount.multipliedBy(rate).toFixed(scale, roundingMode)) : currencyAmountToMap[currency].plus(amount2RMB.toFixed(scale, roundingMode))
         // 针对费用页签等非收付计算场景
         // if (checkOriginal && amount.toNumber() !== 0) {
         //   originalAmountSum = NumberUtils.ToFixed2(originalAmountSum + amount.toNumber(), 2)
         // }
       }
     }
   }

   // 新增：当 currencyConversionInInvoices 参数开启时，在循环结束后统一计算折合金额
   // 逻辑：(USD费用1+USD费用2+...+USD费用n) * USD汇率 + (JPY费用1+JPY费用2+...+JPY费用n) * JPY汇率 = 开票金额
   if (useGroupedInvoiceConversion) {
     for (currency in this.currencyAmountMap) {
       const rate = currencyRateForConversionMap[currency] || 1

       // 处理 AUTO 类型的 AR/AP 折合金额
       if (this.type === ChargeCurrencyTotalGroup.AUTO) {
         // 处理 AR 折合金额: (AR费用1 + AR费用2 + ... + AR费用n) * 汇率
         const arTotalAmount = arCurrencyAmountMap[currency] || new BigNumber(0)
         currencyAmountToArMap[currency] = new BigNumber(arTotalAmount.multipliedBy(rate).toFixed(scale, roundingMode))

         // 处理 AP 折合金额: (AP费用1 + AP费用2 + ... + AP费用n) * 汇率
         const apTotalAmount = apCurrencyAmountMap[currency] || new BigNumber(0)
         currencyAmountToApMap[currency] = new BigNumber(apTotalAmount.multipliedBy(rate).toFixed(scale, roundingMode))
       } else if (this.type === ChargeCurrencyTotalGroup.REVENUE_ABS) {
         // 先累加 AR 和 AP 的原币金额并计算折合金额
         // 对于 REVENUE 类型：折合金额 = (AR总额 - AP总额) * 汇率
         const arTotalAmount = arCurrencyAmountMap[currency] || new BigNumber(0)
         const apTotalAmount = apCurrencyAmountMap[currency] || new BigNumber(0)

         // 计算原币总额
         let totalAmount = this.currencyAmountMap[currency] || new BigNumber(0)

         totalAmount = totalAmount.abs()

         // 计算折合金额：原币总额 * 汇率
         currencyAmountToMap[currency] = new BigNumber(totalAmount.multipliedBy(rate).toFixed(scale, roundingMode))

         // 同时计算 AR 和 AP 的折合金额（用于收付分组显示）
         currencyAmountToArMap[currency] = new BigNumber(arTotalAmount.multipliedBy(rate).toFixed(scale, roundingMode))
         currencyAmountToApMap[currency] = new BigNumber(apTotalAmount.multipliedBy(rate).toFixed(scale, roundingMode))
       }
     }
   }

   // arAmountTo = new BigNumber(arAmountTo.toFixed(scale, roundingMode))
   // apAmountTo = new BigNumber(apAmountTo.toFixed(scale, roundingMode))
   // if (!(arAmountTo.toNumber() === 0 && apAmountTo.toNumber() === 0)) {
   //   amountTo = arAmountTo.plus(apAmountTo)
   // }
   let hasDiffCurrency = false
   const list = []
   if (this.type === ChargeCurrencyTotalGroup.AUTO) {
     let totalArTemp = new BigNumber(0)
     let totalApTemp = new BigNumber(0)
     for (currency in this.currencyAmountMap) {
       totalArTemp = totalArTemp.plus(currencyAmountToArMap[currency])
       totalApTemp = totalApTemp.plus(currencyAmountToApMap[currency])
       if (this.currencyAmountMap[currency].toNumber() !== 0 || currencyRateMap[currency].size > 1) {
         totalAr = totalAr.plus(currencyAmountToArMap[currency])
         totalAp = totalAp.plus(currencyAmountToApMap[currency])
       }
     }
     if (totalAp.toNumber() === 0) {
       amountTo = totalAr
     } else if (totalAr.toNumber() === 0) {
       amountTo = totalAp
     } else {
       if (this.arapOrder === ChargeCurrencyTotalGroup.AP) {
         amountTo = totalAr.minus(totalAp.abs())
       } else {
         amountTo = totalAr.minus(totalAp)
       }
     }
     this.isAr = amountTo.toNumber() > 0
     for (currency in arCurrencyAmountMap) {
       if (!hasDiffCurrency && this.amountToCurrency && this.amountToCurrency !== currency) {
         hasDiffCurrency = true
       }
       const arAmount = arCurrencyAmountMap[currency]
       const apAmount = apCurrencyAmountMap[currency]
       if (totalArTemp.toNumber() === 0 && totalApTemp.toNumber() !== 0) {
         amount = apAmount
       } else if (totalApTemp.toNumber() === 0 && totalArTemp.toNumber() !== 0) {
         amount = arAmount
       } else {
         if (this.arapOrder === ChargeCurrencyTotalGroup.AP) {
           amount = arAmount.minus(apAmount.abs())
         } else {
           amount = arAmount.minus(apAmount)
         }
         if (this.source && this.source === 'billPaymentDialogGroup') {
           amount = new BigNumber(0).minus(amount)
         }
       }
       if (this.onlyShowConvert) {
         continue
       }
       list.push(new CurrencyTotalItem(amount, currency, false))
     }
   } else {
     if (this.arapGroup) {
       let arString = this.arLabel
       let apString = this.apLabel
       for (currency in this.currencyAmountMap) {
         scale = 2 // 小数位数
         roundingMode = BigNumber.ROUND_HALF_UP
         if (carryRule && currency) {
           const currencyData = getCurrency(currency)
           if (currencyData !== null) {
             scale = currencyData.defaultFractionDigits
             if (currencyData.carryRule === 1) { // 进位规则：0=四合五入、1=舍位
               roundingMode = BigNumber.ROUND_DOWN
             } else {
               roundingMode = BigNumber.ROUND_HALF_UP
             }
           }
         }
         if (!hasDiffCurrency && this.amountToCurrency && this.amountToCurrency !== currency) {
           hasDiffCurrency = true
         }
         list.push(new CurrencyTotalItem(arCurrencyAmountMap[currency].toFixed(scale, roundingMode), (arString === this.arLabel ? arString + ' ' : '') + currency, this.type === 'revenue'))
         arString = arString + currency
       }
       for (currency in this.currencyAmountMap) {
         scale = 2 // 小数位数
         roundingMode = BigNumber.ROUND_HALF_UP
         if (carryRule && currency) {
           const currencyData = getCurrency(currency)
           if (currencyData !== null) {
             scale = currencyData.defaultFractionDigits
             if (currencyData.carryRule === 1) { // 进位规则：0=四合五入、1=舍位
               roundingMode = BigNumber.ROUND_DOWN
             } else {
               roundingMode = BigNumber.ROUND_HALF_UP
             }
           }
         }
         if (!hasDiffCurrency && this.amountToCurrency && this.amountToCurrency !== currency) {
           hasDiffCurrency = true
         }
         list.push(new CurrencyTotalItem(apCurrencyAmountMap[currency].toFixed(scale, roundingMode), (apString === this.apLabel ? apString + ' ' : '') + currency, this.type === 'revenue'))
         apString = apString + currency
       }
     } else {
       for (currency in this.currencyAmountMap) {
         if (!hasDiffCurrency && this.amountToCurrency && this.amountToCurrency !== currency) {
           hasDiffCurrency = true
         }
         if (this.type === ChargeCurrencyTotalGroup.REVENUE_ABS) {
           amount = this.currencyAmountMap[currency].abs()
         } else {
           amount = this.currencyAmountMap[currency]
         }
         list.push(new CurrencyTotalItem(amount, currency, this.type === 'revenue'))
       }
     }
   }
   if (this.amountToCurrency && hasDiffCurrency) {
     if (this.type !== ChargeCurrencyTotalGroup.AUTO) {
       for (currency in this.currencyAmountMap) {
         if (this.currencyAmountMap[currency].toNumber() !== 0 ||
             (this.currencyAmountMap[currency].toNumber() === 0 && currencyRateMap[currency].size > 1)) {
           if (currencyRateMap[currency].size > 1) {
             amountTo = amountTo.plus(currencyAmountToMap[currency])
           } else if (currencyRateMap[currency].size === 1 && ['chargeDetailAp', 'chargeDetailAr'].includes(this.source) &&
               this.auxiliaryMap && this.auxiliaryMap.size > 0) {
             // 当应收费用的原币种总金额等于应付费用的原币种总金额，且原币种汇率只有一个，并且请求来自“费用页签详情”时，处理应收应付合计组件中折合RMB差1分钱问题
             const rates = currencyRateMap[currency]
             let amount = currencyAmountToMap[currency].toNumber()
             if (amount && rates) {
               let rate = 0
               rates.forEach((value) => {
                 rate = value
                 return
               })
               const key = currency + '_' + rate
               if (this.auxiliaryMap.has(key)) {
                 const currencyMap = this.auxiliaryMap.get(key)
                 if (currencyMap) {
                   // 原币种金额以及汇率一致
                   if (currencyMap.sourceTotalAmount === this.currencyAmountMap[currency].toNumber()) {
                     amount = NumberUtils.ToFixed2(currencyMap.sourceTotalAmount * currencyMap.rate, 2)
                   }
                 }
               }
             }
             amountTo = amountTo.plus(new BigNumber(amount))
           } else {
             amountTo = amountTo.plus(currencyAmountToMap[currency])
           }
         }
       }
     }
     if (this.type === ChargeCurrencyTotalGroup.REVENUE_ABS) {
       amountTo = amountTo.abs()
     }
     list.push(new CurrencyTotalItem(new BigNumber(amountTo.toFixed(scale, roundingMode)), this.amountToCurrencyLabel + this.amountToCurrency, this.type === 'revenue', true))
     // if (checkOriginal && arOriginalAmountSum - apOriginalAmountSum === 0 && originalAmountSum === 0) {
     //   list.push(new CurrencyTotalItem(new BigNumber(0), this.amountToCurrencyLabel + this.amountToCurrency, this.type === 'revenue', true))
     // } else {
     //   list.push(new CurrencyTotalItem(amountTo.toFixed(scale, roundingMode), this.amountToCurrencyLabel + this.amountToCurrency, this.type === 'revenue', true))
     // }
   }
   if (this.source === 'bankSlip' && list) {
     for (const d of list) {
       d.amount = new BigNumber(d.amount)
     }
   }
   // 处理泰国税
   this.handleWhtRate(scale, roundingMode, localCurrency, list)
   // 新增：添加应收费用利息显示
   if (totalCostInterest.toNumber() !== 0) {
     list.push(new CurrencyTotalItem(new BigNumber(totalCostInterest.toFixed(2, BigNumber.ROUND_HALF_UP)), '应收费用利息(折合' + localCurrency + ')'))
   }
   this.resultList.splice(0, this.resultList.length, ... list)
 }

 handleWhtRate(scale, roundingMode, localCurrency, list) {
   if (this.showWht && $store.getters.currentOffice.whtTaxMode) {
     let totalNotWhtAmount = new BigNumber(0)
     for (const tempItem of this.dataProvider || []) {
       const notWhtAmount = tempItem['chargeNotWhtAmount'] ? tempItem['chargeNotWhtAmount'] : tempItem.notWhtAmount
       if (!notWhtAmount) {
         const localAmount = tempItem.localAmount || 0
         const whtTaxLocalAmount = tempItem.whtTaxLocalAmount || 0
         if (localAmount) {
           tempItem.notWhtAmount = Number(localAmount) - Number(whtTaxLocalAmount)
         } else {
           tempItem.notWhtAmount = 0
         }
       }
       totalNotWhtAmount = totalNotWhtAmount.plus(new BigNumber(notWhtAmount))
     }
     if (list && list.length > 0) {
       list.push(new CurrencyTotalItem(new BigNumber(totalNotWhtAmount.toFixed(scale, roundingMode)), lang.t('FinanceManage.charge_notWhtAmount') + '(' + lang.t('Clearing.Equivalent') + localCurrency + ')'))
     }
   }
 }
}
